import React from 'react';
import { CitationList } from '../CitationList';
import { type Citation, mergeCitations } from '../citations';
import type { CockpitProposal } from './cockpitBackend';

/**
 * Under an answer of the shared assistant: the documentation sources (PDF
 * pages, video scenes) of all its citation events, without duplicates. The
 * cards open the source dialog (CitationViewerHost, at app level).
 */
export const CockpitSources: React.FC<{ proposals: CockpitProposal[] }> = ({ proposals }) => {
  let citations: Citation[] = [];
  for (const p of proposals) {
    if (p.kind === 'citations') citations = mergeCitations(citations, p.citations);
  }
  if (citations.length === 0) return null;
  return (
    <div className="w-full">
      <CitationList citations={citations} />
    </div>
  );
};
